<template>
    <!-- Theme one -->
    <div v-if="themeStore.themeIndex === 1">
        <LoginTreasureViewOne @reset-show-treasure-popup="resetShowTreasurePopup"/>
    </div>

    <!-- theme two -->
    <div v-if="themeStore.themeIndex === 2">
        <LoginTreasureViewTwo @get-deposit-claim="() => emits('getDepositClaim')" @reset-show-treasure-popup="resetShowTreasurePopup"/>
    </div>
</template>

<script setup lang="ts">
import { defineEmits } from 'vue';
import { useThemeStore } from '@/stores/theme';
import LoginTreasureViewOne from '@/themes/themeOne/loginTreasure/loginTreasureView.vue';
import LoginTreasureViewTwo from '@/themes/themeTwo/loginTreasure/loginTreasureView.vue';

const themeStore = useThemeStore()
const emits = defineEmits(['getDepositClaim', 'resetShowTreasurePopup'])
const resetShowTreasurePopup = () => {
    emits('resetShowTreasurePopup')
}
</script>
